import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import geoLanguageDetector from './utils/geoLanguageDetector';

// 自定义语言检测器，用于从URL路径中获取语言
const languagePathDetector = {
  name: 'languagePathDetector',
  type: 'languageDetector',
  
  init: () => {},
  
      detect: () => {
    if (typeof window !== 'undefined') {
      const path = window.location.pathname;
      const langMatch = path.match(/^\/([a-z]{2})(\/.*|$)/);
      if (langMatch && langMatch[1]) {
        const detectedLang = langMatch[1];
        // 检查是否是支持的语言
        if (['zh', 'en', 'ja', 'ko', 'es', 'fr', 'de', 'ru'].includes(detectedLang)) {
          return detectedLang;
        }
      }
    }
    return null;
  },
  
  cacheUserLanguage: (lng) => {
    // 可以缓存用户选择的语言
    localStorage.setItem('i18nextLng', lng);
  }
};

// 语言资源
const resources = {
  zh: {
    translation: {
      // 导航和标题
      title: "StreamMate - Video download tool",
      subtitle: "专业的视频下载工具，支持多平台视频提取和下载",
      
      // 主要功能
      downloadVideo: "下载视频",
      pasteUrl: "粘贴视频链接",
      urlPlaceholder: "请输入视频链接 (支持 YouTube, X, Bilibili, TikTok 等)",
      download: "下载",
      downloading: "下载中...",
      favorite: "收藏",
      
      // 平台支持
      supportedPlatforms: "支持的平台",
      youtube: "YouTube",
      twitter: "X (Twitter)",
      bilibili: "哔哩哔哩",
      tiktok: "TikTok",
      instagram: "Instagram",
      facebook: "Facebook",
      
      // Cookie 管理
      cookieSettings: "Cookie设置",
      cookieDescription: "设置平台cookies以下载会员视频、访问受限内容、获取高质量格式、绕过地区限制等",
      cookieSteps: "获取cookies步骤：",
      cookieStep1: "1. 在浏览器中登录对应平台",
      cookieStep2: "2. 按F12打开开发者工具",
      cookieStep3: "3. 在Console中输入：document.cookie",
      cookieStep4: "4. 复制输出的cookie字符串",
      cookieStep5: "5. 粘贴到下方输入框中",
      platform: "平台",
      cookieValue: "Cookie值",
      netscapeCookie: "Netscape Cookie",
      save: "保存",
      clear: "清除",
      
      // Cookie使用说明（新增）
      whenToUseCookies: "什么情况下需要使用Cookies",
      cookieUseCase1: "下载会员/限制级视频内容时",
      cookieUseCase2: "访问需要登录或地区限制的内容",
      cookieUseCase3: "获取更高质量的视频格式",
      cookieUseCase4: "普通下载失败或被平台限制时",
      howToGetCookies: "如何获取Cookies",
      cookieExtensionGuide: "推荐使用浏览器扩展工具'Get cookies.txt'来获取cookies：",
      cookieExtensionStep1: "安装'Get cookies.txt'或类似的浏览器扩展",
      cookieExtensionStep2: "登录相应的视频平台后，点击扩展图标导出cookies",
      cookieExtensionStep3: "将导出的cookies内容复制粘贴到下方输入框中",
      netscapeCookieRequired: "注意：必须使用Netscape格式的cookies，它包含更完整的认证信息，确保能正常访问需要登录的内容",
      
      // 状态消息
      serviceNormal: "服务正常",
      serviceError: "服务异常",
      error: "错误",
      warning: "警告",
      info: "信息",
      
      // 错误消息
      invalidUrl: "请输入有效的视频链接",
      downloadFailed: "下载失败",
      networkError: "网络错误",
      unsupportedPlatform: "不支持的平台",
      streamFailed: "流式下载失败",
      streamStarted: "流式下载已开始",
      
      // 流式下载
      stream: "直接下载",
      streamDownload: "直接流式下载，不经过服务器存储",
      
      // 其他
      language: "语言",
      settings: "设置",
      about: "关于",
      help: "帮助",
      close: "关闭",
      cancel: "取消",
      confirm: "确认",
      appStore: "App Store"
    }
  },
  en: {
    translation: {
      // Navigation and titles
      title: "StreamMate - Video Downloader",
      subtitle: "Professional video download tool supporting multi-platform video extraction and download",
      
      // Main features
      downloadVideo: "Download Video",
      pasteUrl: "Paste Video URL",
      urlPlaceholder: "Enter video URL (supports YouTube, X, Bilibili, TikTok, etc.)",
      download: "Download",
      downloading: "Downloading...",
      favorite: "Favorite",
      
      // Platform support
      supportedPlatforms: "Supported Platforms",
      youtube: "YouTube",
      twitter: "X (Twitter)",
      bilibili: "Bilibili",
      tiktok: "TikTok",
      instagram: "Instagram",
      facebook: "Facebook",
      
      // Cookie management
      cookieSettings: "Cookie Settings",
      cookieDescription: "Set platform cookies to download member videos, access restricted content, get high-quality formats, bypass regional restrictions, etc.",
      cookieSteps: "Steps to get cookies:",
      cookieStep1: "1. Log in to the corresponding platform in your browser",
      cookieStep2: "2. Press F12 to open developer tools",
      cookieStep3: "3. Enter in Console: document.cookie",
      cookieStep4: "4. Copy the output cookie string",
      cookieStep5: "5. Paste into the input box below",
      platform: "Platform",
      cookieValue: "Cookie Value",
      netscapeCookie: "Netscape Cookie",
      save: "Save",
      clear: "Clear",
      
      // Cookie usage instructions (new)
      whenToUseCookies: "When to use Cookies",
      cookieUseCase1: "When downloading member/restricted video content",
      cookieUseCase2: "When accessing content that requires login or regional restrictions",
      cookieUseCase3: "When getting higher quality video formats",
      cookieUseCase4: "When normal download fails or is restricted by the platform",
      howToGetCookies: "How to get Cookies",
      cookieExtensionGuide: "Recommended to use browser extension tool 'Get cookies.txt' to get cookies:",
      cookieExtensionStep1: "Install 'Get cookies.txt' or similar browser extension",
      cookieExtensionStep2: "Log in to the corresponding video platform and click the extension icon to export cookies",
      cookieExtensionStep3: "Copy and paste the exported cookies content into the input box below",
      netscapeCookieRequired: "Note: Netscape format cookies must be used, as they contain more complete authentication information to ensure normal access to content requiring login",
      
      // Status messages
      serviceNormal: "Service Normal",
      serviceError: "Service Error",
      error: "Error",
      warning: "Warning",
      info: "Info",
      
      // Error messages
      invalidUrl: "Please enter a valid video URL",
      downloadFailed: "Download failed",
      networkError: "Network error",
      unsupportedPlatform: "Unsupported platform",
      streamFailed: "Streaming failed",
      streamStarted: "Streaming started",
      
      // Streaming
      stream: "Stream",
      streamDownload: "Direct streaming download, bypassing server storage",
      
      // Others
      language: "Language",
      settings: "Settings",
      about: "About",
      help: "Help",
      close: "Close",
      cancel: "Cancel",
      confirm: "Confirm",
      appStore: "App Store"
    }
  },
  ja: {
    translation: {
      // ナビゲーションとタイトル
      title: "StreamMate - 動画ダウンローダー",
      subtitle: "マルチプラットフォーム動画抽出・ダウンロードをサポートするプロフェッショナル動画ダウンロードツール",
      
      // メイン機能
      downloadVideo: "動画をダウンロード",
      pasteUrl: "動画URLを貼り付け",
      urlPlaceholder: "動画URLを入力してください（YouTube、X、Bilibili、TikTokなどをサポート）",
      download: "ダウンロード",
      downloading: "ダウンロード中...",
      favorite: "お気に入り",
      
      // プラットフォームサポート
      supportedPlatforms: "サポートされているプラットフォーム",
      youtube: "YouTube",
      twitter: "X (Twitter)",
      bilibili: "Bilibili",
      tiktok: "TikTok",
      instagram: "Instagram",
      facebook: "Facebook",
      
      // Cookie管理
      cookieSettings: "Cookie設定",
      cookieDescription: "プラットフォームのCookieを設定して、メンバー動画のダウンロード、制限コンテンツへのアクセス、高品質フォーマットの取得、地域制限の回避などを行います",
      cookieSteps: "Cookieの取得手順：",
      cookieStep1: "1. ブラウザで対応するプラットフォームにログイン",
      cookieStep2: "2. F12を押して開発者ツールを開く",
      cookieStep3: "3. コンソールに入力：document.cookie",
      cookieStep4: "4. 出力されたCookie文字列をコピー",
      cookieStep5: "5. 下の入力ボックスに貼り付け",
      platform: "プラットフォーム",
      cookieValue: "Cookie値",
      netscapeCookie: "Netscape Cookie",
      save: "保存",
      clear: "クリア",
      
      // Cookie使用说明（新增）
      whenToUseCookies: "何の場合にCookieを使用するか",
      cookieUseCase1: "メンバー動画/制限級動画のダウンロード時",
      cookieUseCase2: "ログインが必要な動画のアクセス時",
      cookieUseCase3: "高画質動画の取得時",
      cookieUseCase4: "通常のダウンロードに失敗した場合",
      howToGetCookies: "Cookieの取得方法",
      cookieExtensionGuide: "ブラウザ拡張機能'Get cookies.txt'をお勧めします：",
      cookieExtensionStep1: "Get cookies.txtまたは同様のブラウザ拡張機能をインストール",
      cookieExtensionStep2: "対応する動画プラットフォームにログインして拡張機能アイコンをクリックしてcookiesをエクスポート",
      cookieExtensionStep3: "エクスポートされたcookiesの内容を下の入力ボックスにコピーして貼り付け",
      netscapeCookieRequired: "注意：Netscape形式のcookiesを使用する必要があります。これにはより完全な認証情報が含まれており、ログインが必要なコンテンツに正常にアクセスできることを確認してください",
      
      // ステータスメッセージ
      serviceNormal: "サービス正常",
      serviceError: "サービス異常",
      error: "エラー",
      warning: "警告",
      info: "情報",
      
      // エラーメッセージ
      invalidUrl: "有効な動画URLを入力してください",
      downloadFailed: "ダウンロードに失敗しました",
      networkError: "ネットワークエラー",
      unsupportedPlatform: "サポートされていないプラットフォーム",
      streamFailed: "ストリーミングに失敗しました",
      streamStarted: "ストリーミングを開始しました",
      
      // ストリーミング
      stream: "ストリーム",
      streamDownload: "サーバー保存をバイパスする直接ストリーミングダウンロード",
      
      // その他
      language: "言語",
      settings: "設定",
      about: "について",
      help: "ヘルプ",
      close: "閉じる",
      cancel: "キャンセル",
      confirm: "確認",
      appStore: "App Store"
    }
  },
  ko: {
    translation: {
      // 내비게이션 및 제목
      title: "StreamMate - 비디오 다운로더",
      subtitle: "멀티플랫폼 비디오 추출 및 다운로드를 지원하는 전문 비디오 다운로드 도구",
      
      // 주요 기능
      downloadVideo: "비디오 다운로드",
      pasteUrl: "비디오 URL 붙여넣기",
      urlPlaceholder: "비디오 URL을 입력하세요 (YouTube, X, Bilibili, TikTok 등 지원)",
      download: "다운로드",
      downloading: "다운로드 중...",
      favorite: "즐겨찾기",
      
      // 플랫폼 지원
      supportedPlatforms: "지원되는 플랫폼",
      youtube: "YouTube",
      twitter: "X (Twitter)",
      bilibili: "Bilibili",
      tiktok: "TikTok",
      instagram: "Instagram",
      facebook: "Facebook",
      
      // 쿠키 관리
      cookieSettings: "쿠키 설정",
      cookieDescription: "플랫폼 쿠키를 설정하여 멤버 비디오 다운로드, 제한된 콘텐츠 액세스, 고품질 형식 획득, 지역 제한 우회 등을 수행합니다",
      cookieSteps: "쿠키 획득 단계:",
      cookieStep1: "1. 브라우저에서 해당 플랫폼에 로그인",
      cookieStep2: "2. F12를 눌러 개발자 도구 열기",
      cookieStep3: "3. 콘솔에 입력: document.cookie",
      cookieStep4: "4. 출력된 쿠키 문자열 복사",
      cookieStep5: "5. 아래 입력 상자에 붙여넣기",
      platform: "플랫폼",
      cookieValue: "쿠키 값",
      netscapeCookie: "Netscape Cookie",
      save: "저장",
      clear: "지우기",
      
      // Cookie使用说明（新增）
      whenToUseCookies: "언제 쿠키를 사용해야 하는지",
      cookieUseCase1: "멤버 비디오/제한된 비디오 다운로드 시",
      cookieUseCase2: "로그인이 필요한 콘텐츠 액세스 시",
      cookieUseCase3: "높은 품질의 비디오 형식 획득 시",
      cookieUseCase4: "일반 다운로드 실패 또는 플랫폼 제한 시",
      howToGetCookies: "쿠키 획득 방법",
      cookieExtensionGuide: "브라우저 확장 도구 'Get cookies.txt'를 추천합니다:",
      cookieExtensionStep1: "Get cookies.txt 또는 유사한 브라우저 확장 도구 설치",
      cookieExtensionStep2: "해당 비디오 플랫폼에 로그인한 후 확장 아이콘을 클릭하여 cookies를 내보내기",
      cookieExtensionStep3: "내보낸 cookies 내용을 아래 입력란에 복사하여 붙여넣기",
      netscapeCookieRequired: "참고: Netscape 형식의 cookies를 사용해야 합니다. 이는 더 완전한 인증 정보를 포함하고 있어 로그인이 필요한 콘텐츠에 정상적으로 액세스할 수 있도록 보장합니다",
      
      // 상태 메시지
      serviceNormal: "서비스 정상",
      serviceError: "서비스 오류",
      error: "오류",
      warning: "경고",
      info: "정보",
      
      // 오류 메시지
      invalidUrl: "유효한 비디오 URL을 입력하세요",
      downloadFailed: "다운로드 실패",
      networkError: "네트워크 오류",
      unsupportedPlatform: "지원되지 않는 플랫폼",
      streamFailed: "스트리밍 실패",
      streamStarted: "스트리밍 시작됨",
      
      // 스트리밍
      stream: "스트림",
      streamDownload: "서버 저장소를 우회하는 직접 스트리밍 다운로드",
      
      // 기타
      language: "언어",
      settings: "설정",
      about: "정보",
      help: "도움말",
      close: "닫기",
      cancel: "취소",
      confirm: "확인",
      appStore: "App Store"
    }
  },
  es: {
    translation: {
      // Navegación y títulos
      title: "StreamMate - Descargador de Videos",
      subtitle: "Herramienta profesional de descarga de videos que soporta extracción y descarga de videos multiplataforma",
      
      // Funciones principales
      downloadVideo: "Descargar Video",
      pasteUrl: "Pegar URL del Video",
      urlPlaceholder: "Ingrese la URL del video (soporta YouTube, X, Bilibili, TikTok, etc.)",
      download: "Descargar",
      downloading: "Descargando...",
      favorite: "Favorito",
      
      // Soporte de plataformas
      supportedPlatforms: "Plataformas Soportadas",
      youtube: "YouTube",
      twitter: "X (Twitter)",
      bilibili: "Bilibili",
      tiktok: "TikTok",
      instagram: "Instagram",
      facebook: "Facebook",
      
      // Gestión de cookies
      cookieSettings: "Configuración de Cookies",
      cookieDescription: "Configure las cookies de la plataforma para descargar videos de miembros, acceder a contenido restringido, obtener formatos de alta calidad, evitar restricciones regionales, etc.",
      cookieSteps: "Pasos para obtener cookies:",
      cookieStep1: "1. Inicie sesión en la plataforma correspondiente en su navegador",
      cookieStep2: "2. Presione F12 para abrir las herramientas de desarrollador",
      cookieStep3: "3. Ingrese en la consola: document.cookie",
      cookieStep4: "4. Copie la cadena de cookie de salida",
      cookieStep5: "5. Pegue en el cuadro de entrada a continuación",
      platform: "Plataforma",
      cookieValue: "Valor de Cookie",
      netscapeCookie: "Netscape Cookie",
      save: "Guardar",
      clear: "Limpiar",
      
      // Cookie usage instructions (new)
      whenToUseCookies: "Cuándo usar Cookies",
      cookieUseCase1: "Cuando se descarguen vídeos de miembros/vídeos de restricción",
      cookieUseCase2: "Cuando se acceda a contenido que requiera inicio de sesión o restricciones regionales",
      cookieUseCase3: "Cuando se obtenga formato de vídeo de alta calidad",
      cookieUseCase4: "Cuando la descarga normal falla o se restringe la plataforma",
      howToGetCookies: "Cómo obtener Cookies",
      cookieExtensionGuide: "Se recomienda usar la extensión del navegador 'Get cookies.txt' para obtener cookies:",
      cookieExtensionStep1: "Instale la extensión 'Get cookies.txt' o similar del navegador",
      cookieExtensionStep2: "Inicie sesión en la plataforma correspondiente del vídeo y haga clic en el icono de extensión para exportar cookies",
      cookieExtensionStep3: "Copie y pegue el contenido de cookies exportado en el cuadro de entrada de abajo",
      netscapeCookieRequired: "Nota: Se deben usar cookies en formato Netscape. Contienen más información de autenticación completa para garantizar el acceso normal a contenido que requiere inicio de sesión",
      
      // Mensajes de estado
      serviceNormal: "Servicio Normal",
      serviceError: "Error de Servicio",
      error: "Error",
      warning: "Advertencia",
      info: "Información",
      
      // Mensajes de error
      invalidUrl: "Por favor ingrese una URL de video válida",
      downloadFailed: "Descarga fallida",
      networkError: "Error de red",
      unsupportedPlatform: "Plataforma no soportada",
      streamFailed: "Falló la transmisión",
      streamStarted: "Transmisión iniciada",
      
      // Streaming
      stream: "Transmitir",
      streamDownload: "Descarga directa por transmisión, sin almacenamiento en servidor",
      
      // Otros
      language: "Idioma",
      settings: "Configuración",
      about: "Acerca de",
      help: "Ayuda",
      close: "Cerrar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      appStore: "App Store"
    }
  },
  fr: {
    translation: {
      // Navigation et titres
      title: "StreamMate - Téléchargeur de Vidéos",
      subtitle: "Outil professionnel de téléchargement de vidéos supportant l'extraction et le téléchargement de vidéos multi-plateformes",
      
      // Fonctions principales
      downloadVideo: "Télécharger la Vidéo",
      pasteUrl: "Coller l'URL de la Vidéo",
      urlPlaceholder: "Entrez l'URL de la vidéo (supporte YouTube, X, Bilibili, TikTok, etc.)",
      download: "Télécharger",
      downloading: "Téléchargement...",
      favorite: "Favori",
      
      // Support des plateformes
      supportedPlatforms: "Plateformes Supportées",
      youtube: "YouTube",
      twitter: "X (Twitter)",
      bilibili: "Bilibili",
      tiktok: "TikTok",
      instagram: "Instagram",
      facebook: "Facebook",
      
      // Gestion des cookies
      cookieSettings: "Paramètres des Cookies",
      cookieDescription: "Configurez les cookies de la plateforme pour télécharger des vidéos de membres, accéder au contenu restreint, obtenir des formats de haute qualité, contourner les restrictions régionales, etc.",
      cookieSteps: "Étapes pour obtenir les cookies :",
      cookieStep1: "1. Connectez-vous à la plateforme correspondante dans votre navigateur",
      cookieStep2: "2. Appuyez sur F12 pour ouvrir les outils de développeur",
      cookieStep3: "3. Entrez dans la console : document.cookie",
      cookieStep4: "4. Copiez la chaîne de cookie de sortie",
      cookieStep5: "5. Collez dans la boîte de saisie ci-dessous",
      platform: "Plateforme",
      cookieValue: "Valeur du Cookie",
      netscapeCookie: "Netscape Cookie",
      save: "Sauvegarder",
      clear: "Effacer",
      
      // Cookie usage instructions (new)
      whenToUseCookies: "Quand utiliser les Cookies",
      cookieUseCase1: "Lors de la téléchargement de vidéos de membres/vidéos de restriction",
      cookieUseCase2: "Lors de l'accès à du contenu nécessitant une connexion ou des restrictions régionales",
      cookieUseCase3: "Lors de la récupération de format de vidéo de haute qualité",
      cookieUseCase4: "Lorsque le téléchargement normal échoue ou est restreint par la plateforme",
      howToGetCookies: "Comment obtenir des Cookies",
      cookieExtensionGuide: "Nous recommandons d'utiliser l'extension du navigateur 'Get cookies.txt' pour obtenir des cookies:",
      cookieExtensionStep1: "Installer l'extension 'Get cookies.txt' ou similaire du navigateur",
      cookieExtensionStep2: "Se connecter à la plateforme correspondante de la vidéo et cliquer sur l'icône d'extension pour exporter les cookies",
      cookieExtensionStep3: "Copier et coller le contenu des cookies exportés dans la case d'entrée ci-dessous",
      netscapeCookieRequired: "Remarque : Les cookies en format Netscape doivent être utilisés. Ils contiennent plus d'informations d'authentification complètes pour garantir l'accès normal aux contenus nécessitant une connexion",
      
      // Messages de statut
      serviceNormal: "Service Normal",
      serviceError: "Service en Erreur",
      error: "Erreur",
      warning: "Avertissement",
      info: "Information",
      
      // Messages d'erreur
      invalidUrl: "Veuillez entrer une URL de vidéo valide",
      downloadFailed: "Échec du téléchargement",
      networkError: "Erreur réseau",
      unsupportedPlatform: "Plateforme non supportée",
      streamFailed: "Échec du streaming",
      streamStarted: "Streaming démarré",
      
      // Streaming
      stream: "Diffuser",
      streamDownload: "Téléchargement direct en streaming, sans stockage sur serveur",
      
      // Autres
      language: "Langue",
      settings: "Paramètres",
      about: "À propos",
      help: "Aide",
      close: "Fermer",
      cancel: "Annuler",
      confirm: "Confirmer",
      appStore: "App Store"
    }
  },
  de: {
    translation: {
      // Navigation und Titel
      title: "StreamMate - Video-Downloader",
      subtitle: "Professionelles Video-Download-Tool mit Unterstützung für Multi-Plattform-Video-Extraktion und -Download",
      
      // Hauptfunktionen
      downloadVideo: "Video Herunterladen",
      pasteUrl: "Video-URL Einfügen",
      urlPlaceholder: "Video-URL eingeben (unterstützt YouTube, X, Bilibili, TikTok, etc.)",
      download: "Herunterladen",
      downloading: "Wird heruntergeladen...",
      favorite: "Favorit",
      
      // Plattform-Unterstützung
      supportedPlatforms: "Unterstützte Plattformen",
      youtube: "YouTube",
      twitter: "X (Twitter)",
      bilibili: "Bilibili",
      tiktok: "TikTok",
      instagram: "Instagram",
      facebook: "Facebook",
      
      // Cookie-Verwaltung
      cookieSettings: "Cookie-Einstellungen",
      cookieDescription: "Plattform-Cookies konfigurieren, um Mitglieder-Videos herunterzuladen, auf eingeschränkte Inhalte zuzugreifen, hochwertige Formate zu erhalten, regionale Beschränkungen zu umgehen, etc.",
      cookieSteps: "Schritte zum Abrufen von Cookies:",
      cookieStep1: "1. Melden Sie sich in Ihrem Browser bei der entsprechenden Plattform an",
      cookieStep2: "2. Drücken Sie F12, um die Entwicklertools zu öffnen",
      cookieStep3: "3. Geben Sie in der Konsole ein: document.cookie",
      cookieStep4: "4. Kopieren Sie die ausgegebene Cookie-Zeichenfolge",
      cookieStep5: "5. Fügen Sie sie in das Eingabefeld unten ein",
      platform: "Plattform",
      cookieValue: "Cookie-Wert",
      netscapeCookie: "Netscape Cookie",
      save: "Speichern",
      clear: "Löschen",
      
      // Cookie usage instructions (new)
      whenToUseCookies: "Wann Cookies verwenden",
      cookieUseCase1: "Wenn Sie Videos von Mitgliedern/beschränkten Videos herunterladen",
      cookieUseCase2: "Wenn Sie auf Inhalte zugreifen, die eine Anmeldung oder regionale Einschränkungen erfordern",
      cookieUseCase3: "Wenn Sie ein hochwertiges Videosformat erhalten",
      cookieUseCase4: "Wenn die normale Herunterladung fehlschlägt oder die Plattform eingeschränkt wird",
      howToGetCookies: "Wie Cookies erhalten",
      cookieExtensionGuide: "Es wird empfohlen, die Browser-Erweiterung 'Get cookies.txt' zu verwenden, um Cookies zu erhalten:",
      cookieExtensionStep1: "Die Erweiterung 'Get cookies.txt' oder eine ähnliche Browser-Erweiterung installieren",
      cookieExtensionStep2: "Sich bei der entsprechenden Video-Plattform anmelden und das Erweiterungssymbol klicken, um Cookies zu exportieren",
      cookieExtensionStep3: "Die exportierten Cookies-Inhalte in das Eingabefeld unten kopieren und einfügen",
      netscapeCookieRequired: "Hinweis: Es müssen Netscape-formatierte Cookies verwendet werden. Sie enthalten mehr vollständige Authentifizierungsinformationen, um normalen Zugriff auf Inhalte zu gewährleisten, die eine Anmeldung erfordern",
      
      // Statusmeldungen
      serviceNormal: "Dienst Normal",
      serviceError: "Dienst Fehler",
      error: "Fehler",
      warning: "Warnung",
      info: "Information",
      
      // Fehlermeldungen
      invalidUrl: "Bitte geben Sie eine gültige Video-URL ein",
      downloadFailed: "Download fehlgeschlagen",
      networkError: "Netzwerkfehler",
      unsupportedPlatform: "Nicht unterstützte Plattform",
      streamFailed: "Streaming fehlgeschlagen",
      streamStarted: "Streaming gestartet",
      
      // Streaming
      stream: "Streamen",
      streamDownload: "Direktes Streaming-Download ohne Serverspeicherung",
      
      // Andere
      language: "Sprache",
      settings: "Einstellungen",
      about: "Über",
      help: "Hilfe",
      close: "Schließen",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      appStore: "App Store"
    }
  },
  ru: {
    translation: {
      // Навигация и заголовки
      title: "StreamMate - Загрузчик Видео",
      subtitle: "Профессиональный инструмент для загрузки видео с поддержкой извлечения и загрузки видео с множественных платформ",
      
      // Основные функции
      downloadVideo: "Скачать Видео",
      pasteUrl: "Вставить URL Видео",
      urlPlaceholder: "Введите URL видео (поддерживает YouTube, X, Bilibili, TikTok и др.)",
      download: "Скачать",
      downloading: "Загрузка...",
      favorite: "Избранное",
      
      // Поддержка платформ
      supportedPlatforms: "Поддерживаемые Платформы",
      youtube: "YouTube",
      twitter: "X (Twitter)",
      bilibili: "Bilibili",
      tiktok: "TikTok",
      instagram: "Instagram",
      facebook: "Facebook",
      
      // Управление cookies
      cookieSettings: "Настройки Cookies",
      cookieDescription: "Настройте cookies платформы для загрузки видео участников, доступа к ограниченному контенту, получения высококачественных форматов, обхода региональных ограничений и т.д.",
      cookieSteps: "Шаги для получения cookies:",
      cookieStep1: "1. Войдите в соответствующую платформу в вашем браузере",
      cookieStep2: "2. Нажмите F12, чтобы открыть инструменты разработчика",
      cookieStep3: "3. Введите в консоли: document.cookie",
      cookieStep4: "4. Скопируйте выведенную строку cookie",
      cookieStep5: "5. Вставьте в поле ввода ниже",
      platform: "Платформа",
      cookieValue: "Значение Cookie",
      netscapeCookie: "Netscape Cookie",
      save: "Сохранить",
      clear: "Очистить",
      
      // Cookie usage instructions (new)
      whenToUseCookies: "Когда использовать Cookies",
      cookieUseCase1: "Когда вы скачиваете видео с участием/ограниченного видео",
      cookieUseCase2: "Когда вы получаете доступ к контенту, который требует входа или региональных ограничений",
      cookieUseCase3: "Когда вы получаете высококачественный формат видео",
      cookieUseCase4: "Когда обычная загрузка не удается или платформа ограничена",
      howToGetCookies: "Как получить Cookies",
      cookieExtensionGuide: "Рекомендуем использовать расширение браузера 'Get cookies.txt' для получения cookies:",
      cookieExtensionStep1: "Установите расширение 'Get cookies.txt' или подобное браузерное расширение",
      cookieExtensionStep2: "Войдите в соответствующую видеоплатформу и нажмите значок расширения, чтобы экспортировать cookies",
      cookieExtensionStep3: "Скопируйте и вставьте содержимое экспортированных cookies в поле ввода ниже",
      netscapeCookieRequired: "Примечание: Для доступа к контенту, требующему вход, необходимо использовать cookies в формате Netscape. Они содержат более полную информацию для аутентификации, чтобы обеспечить нормальный доступ",
      
      // Сообщения о статусе
      serviceNormal: "Сервис в норме",
      serviceError: "Ошибка сервиса",
      error: "Ошибка",
      warning: "Предупреждение",
      info: "Информация",
      
      // Сообщения об ошибках
      invalidUrl: "Пожалуйста, введите действительный URL видео",
      downloadFailed: "Загрузка не удалась",
      networkError: "Ошибка сети",
      unsupportedPlatform: "Неподдерживаемая платформа",
      streamFailed: "Ошибка потоковой передачи",
      streamStarted: "Потоковая передача началась",
      
      // Streaming
      stream: "Поток",
      streamDownload: "Прямая потоковая загрузка, минуя хранение на сервере",
      
      // Другое
      language: "Язык",
      settings: "Настройки",
      about: "О программе",
      help: "Помощь",
      close: "Закрыть",
      cancel: "Отмена",
      confirm: "Подтвердить",
      appStore: "App Store"
    }
  }
};

// 自定义语言检测器，集成地理位置检测
const customLanguageDetector = {
  type: 'languageDetector',
  async: true,
  
  detect: async (callback) => {
    try {
      // 1. 首先检查localStorage中是否有用户手动设置的语言
      const savedLanguage = localStorage.getItem('i18nextLng');
      if (savedLanguage && geoLanguageDetector.isLanguageSupported(savedLanguage)) {
        console.log('使用用户保存的语言设置:', savedLanguage);
        callback(savedLanguage);
        return;
      }

      // 2. 直接使用英文作为默认语言，不再进行地理位置检测
      console.log('使用默认语言: en');
      callback('en');
    } catch (error) {
      console.warn('语言检测失败，使用默认语言:', error);
      callback('en'); // 默认使用英文
    }
  },
  
  init: () => {},
  cacheUserLanguage: (lng) => {
    try {
      localStorage.setItem('i18nextLng', lng);
    } catch (error) {
      console.warn('保存语言设置失败:', error);
    }
  }
};

i18n
  .use(languagePathDetector) // 首先检测URL路径中的语言
  .use(customLanguageDetector) // 其次使用自定义检测器
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // 修改默认语言为英文
    debug: false,
    
    detection: {
      order: ['languagePathDetector', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    interpolation: {
      escapeValue: false,
    },
  });

// 导出检测器，供其他组件使用
export { geoLanguageDetector, languagePathDetector };

// 支持的语言列表
export const supportedLanguages = ['zh', 'en', 'ja', 'ko', 'es', 'fr', 'de', 'ru'];

export default i18n; 